import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  // Layout
  urlBar: {
    background: '#16213e',
    padding: '14px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    borderBottom: '1px solid #0f3460',
  },
  urlRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  urlBarLabel: {
    color: '#94a3b8',
    fontSize: '0.78rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  reqTextarea: {
    flex: 1,
    minWidth: '300px',
    padding: '9px 14px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    fontSize: '0.82rem',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    '& textarea': {
      color: '#e2e8f0',
      padding: '6px 8px',
    },
  },
  container: {
    padding: '20px 32px',
  },
  // Stats bar
  statsBar: {
    display: 'flex',
    gap: '14px',
    padding: '12px 32px',
    background: '#fff',
    borderBottom: '1px solid #e5e7eb',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  statPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '5px 14px',
    borderRadius: '20px',
    fontSize: '0.78rem',
    fontWeight: 600,
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #bfdbfe',
  },
  statPillGreen: {
    background: '#f0fdf4',
    color: '#166534',
    borderColor: '#bbf7d0',
  },
  statPillAmber: {
    background: '#fffbeb',
    color: '#92400e',
    borderColor: '#fde68a',
  },
  statPillStrong: {
    fontWeight: 800,
  },
  // Filter bar
  filterBar: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '12px 18px',
    borderBottom: '1px solid #f1f5f9',
  },
  filterInput: {
    minWidth: '200px',
    padding: '3px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '0.85rem',
    background: '#fff',
    '& input': {
      padding: '6px 8px',
    },
  },
  selectPaper: {
    maxHeight: '300px',
    marginTop: '4px',
  },
  filterRight: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginLeft: 'auto',
    flexWrap: 'wrap',
  },
  resultCount: {
    fontSize: '0.78rem',
    color: '#64748b',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  // Card
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
    overflow: 'hidden',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  // Buttons
  submitBtn: {
    marginLeft: 'auto',
    padding: '9px 22px',
    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  exportBtn: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg, #065f46, #059669)',
    color: '#fff',
    borderRadius: '8px',
    fontSize: '0.82rem',
    fontWeight: 700,
    '&:hover': {
      opacity: 0.88,
    },
  },
  clearBtn: {
    padding: '6px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '0.78rem',
    fontWeight: 600,
    background: '#fff',
    color: '#64748b',
    cursor: 'pointer',
    '&:hover': {
      background: '#f1f5f9',
    },
  },
  // Table
  perfTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.8rem',
    '& thead th': {
      background: '#335977',
      padding: '8px 6px',
      textAlign: 'center',
      fontSize: '0.72rem',
      fontWeight: 700,
      color: '#FFE784',
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      borderBottom: '2px solid #e5e7eb',
      whiteSpace: 'nowrap',
    },
    '& thead th:nth-child(1)': {
      textAlign: 'center',
      width: '36px',
    },
    '& thead th:nth-child(2)': {
      textAlign: 'left',
      width: '90px',
    },
    '& thead th:nth-child(3)': {
      textAlign: 'left',
      minWidth: '120px',
    },
    '& tbody tr': {
      borderBottom: '1px solid #f1f5f9',
      transition: 'background 0.1s',
      '&:hover': {
        background: '#f8fafc',
      },
    },
    '& tbody td': {
      padding: '5px 6px',
      verticalAlign: 'middle',
      textAlign: 'center',
    },
    '& tbody td:nth-child(2)': {
      textAlign: 'left',
    },
    '& tbody td:nth-child(3)': {
      textAlign: 'left',
    },
  },
  // TableData required styles
  tableHeader: {
    fontWeight: 700,
    backgroundColor: '#335977',
    whiteSpace: 'nowrap',
  },
  isBold: {
    fontWeight: 700,
    color: '#FFFFFF',
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  sortUp: {
    marginBottom: '-8px',
  },
  sortDown: {
    marginTop: '-4px',
  },
  active: {
    color: '#FFE784',
  },
  inactive: {
    color: '#b0bac6',
  },
  emptyTableContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '150px',
    flexDirection: 'column',
  },
  titleWrapper: {
    fontSize: '0.8rem',
  },
  // Pagination styles
  paginationBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 18px',
    borderTop: '1px solid #e5e7eb',
    background: '#fafbfc',
    fontSize: '0.78rem',
    flexWrap: 'wrap',
    gap: '8px',
  },
  paginationLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paginationRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  paginationLabel: {
    color: '#64748b',
    fontSize: '0.78rem',
  },
  paginationSelect: {
    padding: '2px 8px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    fontSize: '0.78rem',
    background: '#fff',
    cursor: 'pointer',
  },
  paginationInfo: {
    color: '#334155',
    fontSize: '0.78rem',
    fontWeight: 600,
  },
  paginationArrow: {
    minWidth: '28px',
    width: '28px',
    height: '28px',
    padding: 0,
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '0.82rem',
    color: '#475569',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#f1f5f9',
    },
    '&:disabled': {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },
  paginationPageBtn: {
    minWidth: '28px',
    width: '28px',
    height: '28px',
    padding: 0,
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '0.78rem',
    color: '#475569',
    '&:hover': {
      background: '#f1f5f9',
    },
  },
  paginationPageBtnActive: {
    background: '#2563eb',
    color: '#fff',
    borderColor: '#2563eb',
    '&:hover': {
      background: '#1d4ed8',
    },
  },
  paginationEllipsis: {
    color: '#94a3b8',
    fontSize: '0.78rem',
    padding: '0 4px',
  },
  // Index cell
  indexCell: {
    color: '#9ca3af',
    fontSize: '0.75rem',
    textAlign: 'center',
    width: '36px',
  },
  // Chips
  chipBlue: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #bfdbfe',
    whiteSpace: 'nowrap',
  },
  chipPurple: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    background: '#faf5ff',
    color: '#7c3aed',
    border: '1px solid #e9d5ff',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: '240px',
    lineHeight: 1.4,
  },
  // Score badges
  scoreGreat: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#f0fdf4',
    color: '#166534',
    border: '1px solid #bbf7d0',
  },
  scoreGood: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #bfdbfe',
  },
  scoreWarn: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#fffbeb',
    color: '#92400e',
    border: '1px solid #fde68a',
  },
  scoreBad: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca',
  },
  scoreNull: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#f9fafb',
    color: '#9ca3af',
    border: '1px solid #e5e7eb',
  },
  // Event count chip
  eventCountChip: {
    display: 'inline-block',
    padding: '1px 8px',
    borderRadius: '10px',
    fontSize: '0.68rem',
    fontWeight: 600,
    marginLeft: '4px',
    background: '#eef2ff',
    color: '#4338ca',
    border: '1px solid #c7d2fe',
  },
  eventCountFailure: {
    background: '#fef2f2',
    color: '#dc2626',
    borderColor: '#fecaca',
  },
  // Date cell row
  dateCellRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  // Drill button
  drillBtn: {
    minWidth: '24px',
    width: '24px',
    height: '24px',
    padding: 0,
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '0.65rem',
    color: '#64748b',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s',
    '&:hover': {
      background: '#f1f5f9',
    },
  },
  drillBtnOpen: {
    transform: 'rotate(180deg)',
  },
  // Expand row
  expandRow: {
    background: '#f8fafc',
  },
  expandInner: {
    padding: '16px 20px',
  },
  expandHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '12px',
    flexWrap: 'wrap',
  },
  expandTitle: {
    fontWeight: 700,
    fontSize: '0.88rem',
    color: '#1e293b',
  },
  expandMeta: {
    fontSize: '0.78rem',
    color: '#64748b',
  },
  expandActions: {
    display: 'flex',
    gap: '8px',
    marginLeft: 'auto',
  },
  // Drill-down sub-table
  drillTable: {
    width: '90vw',
    borderCollapse: 'collapse',
    fontSize: '0.78rem',
    tableLayout: 'fixed',
    '& thead th': {
      background: '#f1f5f9',
      padding: '6px 10px',
      textAlign: 'right',
      fontSize: '0.7rem',
      fontWeight: 700,
      color: '#475569',
      letterSpacing: '0.4px',
      textTransform: 'uppercase',
      borderBottom: '1px solid #e2e8f0',
      whiteSpace: 'nowrap',
    },
    '& thead th:first-child': {
      textAlign: 'left',
      width: '28%',
    },
    '& thead th:nth-child(n+2)': {
      width: '14.4%',
    },
    '& tbody tr': {
      borderBottom: '1px solid #f1f5f9',
    },
    '& tbody td': {
      padding: '4px 10px',
      textAlign: 'right',
      fontSize: '0.76rem',
    },
    '& tbody td:first-child': {
      textAlign: 'left',
      fontFamily: "'SF Mono', 'Fira Code', monospace",
      fontSize: '0.72rem',
    },
  },
  drillRowHidden: {
    display: 'none',
  },
  perfPerfect: {
    color: '#16a34a',
    fontWeight: 700,
  },
  // Failure reason tooltip
  failureTooltip: {
    position: 'relative',
    cursor: 'help',
    '&:hover $failureTooltipText': {
      visibility: 'visible',
      opacity: 1,
    },
  },
  failureTooltipText: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    background: '#1e293b',
    color: '#fff',
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '0.7rem',
    whiteSpace: 'nowrap',
    zIndex: 10,
    transition: 'opacity 0.15s',
    marginBottom: '4px',
  },
  // Missing date cell
  missingDate: {
    color: '#d1d5db',
    fontStyle: 'italic',
    fontSize: '0.75rem',
  },
}))

export { useStyles }
